import React from "react"

import { Props } from "./SimpleFacts.interface"
import { AnimateWrapper } from "@components/main/animate-wrapper/AnimateWrapper"

import * as s from "./SimpleFacts.module.scss"

export const SimpleFacts = ({ data }: Props) => {
  const facts = data.facts

  const colorClass = color => {
    switch (color) {
      case "black":
        return s.simpleFacts__card___black
        break
      case "red":
        return s.simpleFacts__card___red
        break
      case "yellow":
        return s.simpleFacts__card___yellow
        break
    }
  }

  if (!data || !facts) return <></>

  return (
    <div
      className={`${s.simpleFacts} ${
        data.facts[0].blockColor === "yellow" ? s.simpleFacts__yellow : ""
      }`}
    >
      <AnimateWrapper>
        {data.title && <h4> {data.title}</h4>}
        <div
          className={`${
            data.title ? s.simpleFacts__flexTitle : s.simpleFacts__flex
          } ${
            data.facts[0].blockColor === "yellow"
              ? s.simpleFacts__flex___yellow
              : ""
          }`}
        >
          {facts.map((fact, idx) => {
            return (
              <div
                key={idx}
                className={`${s.simpleFacts__card} ${colorClass(
                  fact.blockColor,
                )}`}
              >
                {fact.image && (
                  <div className={s.simpleFacts__card___image}>
                    <img src={fact.image.sourceUrl} alt={fact.title} />
                  </div>
                )}
                <span
                  className={
                    fact.blockColor === "black"
                      ? s.simpleFacts__card___blackUnderline
                      : ""
                  }
                />
                {fact.title && (
                  <div className={s.simpleFacts__card___title}>
                    {fact.title}
                  </div>
                )}
                <div className={s.simpleFacts__card___blurb}>
                  <p>{fact.blurb}</p>
                </div>
              </div>
            )
          })}
        </div>
      </AnimateWrapper>
    </div>
  )
}
